import { render, staticRenderFns } from "./AddressPostcode.vue?vue&type=template&id=53d192fd&"
import script from "./AddressPostcode.vue?vue&type=script&lang=ts&"
export * from "./AddressPostcode.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports